<div class="parent">
    <div class="header"><app-header></app-header></div>
    <div class="main" *ngIf="results$ | async; let results; else showLoading">
        <ul class="responsive-side_nav" *ngIf="recordResults && recordResults.length > 0">
            <button class="btn btn-sm btn-container sort-btn btn-filter" (click)="showModal(results)">
                <i class="fas fa-filter"></i>
                <h1>{{'msg#label.filters' | sqMessage}}</h1>
            </button>
            <li>
                <div class="sort_by">
                    <em>{{'msg#label.sortBy' | sqMessage}}</em>
                    <div class="d-flex sq-toolbar">
                        <sq-sort-selector [hideSearch]="true" [results]="results"
                            [rightAligned]="true"></sq-sort-selector>
                    </div>
                </div>
            </li>
        </ul>
        <div class="side-nav"  [@myState]="state">
            <div (click)="toggleSidebar();"><i *ngIf="state == 'inactive'" class="fa fa-bars fas-angle-custom" ></i><i *ngIf="state == 'active'" class="fas fa-angle-left fas-angle-custom" ></i></div>
            <ul>
                <li>
                    <div class="pt-4">
                        <em>{{'msg#label.sortBy' | sqMessage}}</em>
                        <sq-sort-selector [hideSearch]="true" [results]="results"
                            [rightAligned]="true"></sq-sort-selector>
                    </div>
                    <app-filters [results]="results" [aggregations]="aggregations"></app-filters>
                </li>
            </ul>
        </div>
        <div class="child content">
            <div class="search-wrapper">
                <app-search-form #searchform [hideSearch]="true" [recordResults]="recordResults"></app-search-form><br>
            </div>
            <div class="search-wrapper">
                <p class="upload">{{'msg#label.upload' |
                    sqMessage}} <a href="https://azcollaboration.sharepoint.com/sites/TSN760" target="_blank">
                        <strong>{{'msg#label.uploadURL' |
                            sqMessage}}</strong></a></p>
            </div>
            <div class="btn-container">
                <label class="btn-label form-label" for="alertFrequency">{{'msg#label.lookFor' |
                    sqMessage}}</label>
                <button *ngFor="let item of btnLabels" type="button" (click)="selectedBtn(item)"
                    [ngClass]="{'btn-align': item.name == results.tab}"
                    class="button btn btn-outline-secondary btn-sm rounded-pill ms-1 mb-1">
                    {{item.display |
                    sqValue:item}}
                </button>
                <span class="result-count-container">
                    <div class="sq-results-count small my-2 ms-auto px-2">{{title}}
                        {{'msg#results.resultsCount' | sqMessage:{values: {count: searchService.rowCount} }
                        }}</div>
                </span>
            </div>

            <div class="container-fluid">

                
                <ng-container *ngIf="( customService?.dataSubject | async); else showAssistLoading">
                    <div class="asst_msg" *ngIf="history">
                        <div class="warning-container">
                            <!-- <span class="warning-icon">&#x26a0;</span> -->
                            <i class="fas fa-thin fa-exclamation-triangle warning-icon"></i>
                            <span class="warning-text">Insights Vault Assistant is in PILOT. Users must review and verify the accuracy, truthfulness, safety, and appropriateness of AI outputs, and if they are harmful or biased, prior to sharing, relying on or using those outputs. Any feedback from the Pilot Testing that you can provide would be very much appreciated.</span>
                            </div>
                       <div (click)="copyToClipboard()" title="click to copy to clipboard"> 
                            <i class="fas fa-copy copy-icon"></i>
                            <!-- <i class="fas fa-assistive-listening-systems copy-icon"></i> -->
                        </div>
                        <ng-template #popTemplate id="commentPopover">
                            <div style="max-height: 6em;overflow: auto;" id="divPopover">
                            </div>
                          <a href="https://i-am-souravdutta.firebaseapp.com/" target="_blank">Open my webpage</a> 
                        </ng-template>
                        <div class="feedback" *ngIf="copied"><small>copied to clipboard</small></div> 
                        <!-- <ng-container *ngIf="{template : customService?.dataSubject | async} as sub">
                            <div id="elementToCopy" [innerHTML]="sub.template?.content | boldStar" ></div>
                            <ng-container *ngIf="sub.template?.content.indexOf('Sorry, you may have reached the maximum permitted token limit') == 0">
                                <button class="btn btn-primary cust-btn" (click)="searchform.frameAssistantQuery(searchService.query)">Reload</button>  </ng-container>
                        </ng-container> -->
                        <!-- {{asst_response | json}} -->
                        <div class="framedHTML" id="elementToCopy" >
                            
                            <app-html-node [nodes]="asst_response" [context]="asst_context" [lines]="this.noOflines"></app-html-node>                                  

                            <ng-container *ngIf="response.indexOf('Sorry, you may have reached the maximum permitted token limit') == 0;">
                                <button class="btn btn-primary cust-btn" (click)="searchform.frameAssistantQuery(searchService.query)">Reload</button>
                            </ng-container>
                        <!-- <ng-container *ngFor="let node of asst_response">
                            <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: node }"></ng-container>
                          </ng-container> -->
                        </div>
                          

                        <!-- {{( customService?.dataSubject | async)}} -->
                        <ng-container *ngIf="history && history.length > 0">
                            <p class="ref_title accordion" (click)="openAcc()">Reference:</p>
                            <ol class="list-color" *ngIf="isAccordionVisible">
                                <ng-container *ngFor="let item of history ">
                                    <li *ngIf="item.additionalProperties.display === false">
                                        <a target="_blank" (click)="searchform.audit(item.additionalProperties.record?.id,'assistant.reference.clicked')"
                                            [href]="item.additionalProperties.record?.url1">{{item.additionalProperties.record?.title}}</a>
                                    </li>
                                </ng-container>
                            </ol>
                        </ng-container>

                    </div>
                </ng-container>
            </div>
            <div class="container-fluid record-wrapper">

                <ul class="results-table result-list p-0"
                    *ngIf="recordResults && recordResults.length > 0; else noResultsFound">
                    <ul *ngFor="let record of recordResults;let islast = last " class="record"
                        (click)="onDocumentClicked(record, $event)" [ngClass]="{
        'selected': record.$selected || record === openedDoc,
        'duplicate': record.$isDuplicate
                        }">
                        <div style="display: flex;">
                            <app-result-thumbnail [record]="record" [linkBehavior]="true"
                                *ngIf="record.doctype != 'Folder' && record.doctype != 'Site Collection' && record.doctype != 'List' && record.doctype != 'Site Page'; else folderType"
                                class="d-flex align-self-center ms-3">
                            </app-result-thumbnail>
                            <ng-template #folderType>
                                <i class="fa fa-folder-open fa-2x folder-align"></i>
                            </ng-template>
                            <!-- <sq-result-duplicates-spacer [record]="record"></sq-result-duplicates-spacer> -->
                            <div class="flex-grow-1 result-align"
                                [ngClass]="{'folder-result-align': record.doctype == 'Folder'}">
                                <div class="d-flex align-items-center">
                                    <app-result-title [record]="record"
                                        (titleClicked)="openPreviewIfNoUrl(record, $event)"></app-result-title>
                                </div>
                                <!-- <sq-result-source [record]="record" [displayTreepath]="true"></sq-result-source> -->
                                <sq-result-extracts [record]="record" class="d-block overflow-hidden"
                                    [hideCreatedDate]="true"></sq-result-extracts>
                                <sq-result-missing-terms [record]="record"></sq-result-missing-terms>

                                <sq-labels [record]="record" [public]="true"></sq-labels>
                                <sq-labels [record]="record" [public]="false"></sq-labels>

                                <!-- <sq-result-duplicates [record]="record"></sq-result-duplicates> -->
                            </div>
                        </div>
                        <hr *ngIf="!islast">
                    </ul>
                </ul>
            </div>
            <sq-pager *ngIf="recordResults && recordResults.length > 0" [results]="results"
                class="d-flex flex-column align-items-center mb-2"></sq-pager>
        </div>
    </div>
    <ng-template #showLoading>
        <div class="loading-bar d-flex flex-column align-items-center">
            <h1>{{'msg#loadingLabel.loading' | sqMessage}}...</h1>
            <img src="assets/loading.gif">
        </div>
    </ng-template>
    <ng-template #showAssistLoading>
        <div class="asst_msg align-items-center">
            <p>Assistant typing...</p>
        </div>
    </ng-template>
    <ng-template #noResultsFound>
        <div class="align-items-center empty-result">
            <h1>No Results Found</h1>
        </div>
    </ng-template>
    <div class="footer"><app-footer></app-footer></div>
</div>